import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: { open: false, text: '' },
  detail: { open: false, data: '' },
  detailModal: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setDetail(state, action) {
      state.detail = action.payload;
    },
    setDetailModal(state, action) {
      state.detailModal = action.payload;
    },
    resetUI(state) {
      state.loading = { open: false, text: '' };
      state.detail = { open: false, data: '' };
      state.detailModal = false;
    },
  },
});

export const { setLoading, setDetail, setDetailModal, resetUI } = uiSlice.actions;

export default uiSlice.reducer;
